module.exports = __webpack_public_path__ + "static/img/4.13d8681.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/04/4.png
// module id = MfXT
// module chunks = 2